<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-balance-scale"></i> Relatórios - Ajuizamento</h3>
      </div>
    </div>
    <!-- <NxDataGrid :load="load">
      <NxDataGridColumn field="protocolo" title="PROTOCOLO"/>
      <NxDataGridColumn field="pessoaDocument" title="CPF/CNPJ"/>
      <NxDataGridColumn field="pessoaNome" title="NOME"/>
      <NxDataGridColumn field="quadroNome" title="QUADRO">
        <NxDataGridItem>
          <template #default="{ item }">
            teste: {{ item.protocolo }}
          </template>
        </NxDataGridItem>
      </NxDataGridColumn>
      <NxDataGridColumn field="quadroColunaNome" title="COLUNA" :sortable="false" />
    </NxDataGrid> -->

    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="showConfirmationModal">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
        <a href="javascript:void(0);" id="popover-report-collumn">
          <i class="fas fa-columns text-third" style="font-size: 15px"></i>
        </a>
        <b-popover target="popover-report-collumn" triggers="hover" placement="bottomleft">
          <template #title>Adicionar/ Remover Colunas</template>
          <div class="pb-3">
            <div class="pb-3" style="font-size:9px">
              Clique para adicionar/ remover colunas na grid
            </div>
            <div class="pl-4" >
              <div v-for="(item,index) in columnsOpt" :key="index">
                <b-form-checkbox v-model="item.value" name="check-button" switch @change="setVisibleColumns">
                  {{item.label}}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </b-popover>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn v-if="columnsOpt[0].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.protocolo ? obj.protocolo : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[1].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.document ? obj.document : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[2].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[3].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.responsavel ? obj.responsavel : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[4].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.nomePa ? obj.nomePa.toUpperCase() + ' - ' + obj.numeroPa : '-'" />
          <TableColumn v-if="columnsOpt[5].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.diasEmAberto ? obj.diasEmAberto : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[6].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.numeroProcesso ? obj.numeroProcesso : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[7].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.instancia ? obj.instancia : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[8].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.assunto ? obj.assunto : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[9].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.objetoAcao ? obj.objetoAcao : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[10].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.comarca ? obj.comarca : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[11].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.advogadoResponsavel ? obj.advogadoResponsavel : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[12].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.advogadoContrario ? obj.advogadoContrario : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[13].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.prognostico ? obj.prognostico : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[14].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.valorCausa ? obj.valorCausa : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[15].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.valorCausa2 ? obj.valorCausa2 : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[16].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.dataDistribuicao ? formatDateAndTime(obj.dataDistribuicao) : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[17].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.fase ? obj.fase : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[18].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.ultimoAndamento ? formatDateAndTime(obj.ultimoAndamento) : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[19].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.produto ? obj.produto : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[20].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.valor ? obj.valor : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[21].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.quadroNome ? obj.quadroNome : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[22].value" :IsText="true"  v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.abertura ? formatDateAndTime(obj.abertura) : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[23].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.criador ? obj.criador : ' '" />
          <TableColumn v-if="columnsOpt[24].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.situacao ? obj.situacao : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[25].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.gerente ? obj.gerente : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[26].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.gerenteRelacionamento ? obj.gerenteRelacionamento : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[27].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.origem ? obj.origem : 'NÃO POSSUI'" />
          <TableColumn v-if="columnsOpt[28].value" :IsText="true"   v-on:Edit="openCard(obj.cardId)" :status="obj.inative ? 0 : 1" :value="obj.agendamento ? formatDateAndTime(obj.agendamento) : 'NÃO POSSUI'" />
        </template>
      </tr>
    </Tables>
    <ModalCard ref="ModalCard" v-if="selectedCard" :boardColumns="[]" @hideModal="closeCard" :key="selectedCard"
    :cardId="selectedCard" />
    <SidebarSearch @search="onSearch" />
    <AddConfirmation
      ref="confirmation-modal"
      :saveFunction="onExportExcel"
      :warnText="'Deseja extrair o relatório em arquivo Excel?'"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportAjuizamentoRepository from '@/shared/http/repositories/crm/reportAjuizamento.js'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

import { NxDataGrid, NxDataGridColumn, NxDataGridItem } from '@/components/nexum/components'
import SidebarSearch from '@/views/private/reports/ajuizamento/search/SidebarRelatorioAjuizamento.vue'
import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'
import {CookieUtils} from '../../../../shared/utils/cookiesUtils'
import {toast} from '../../../../shared/utils/UIHelper'

export default {
  name: 'ReportAjuizamento',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: {
        'protocolo': null,
        'document': null,
        'numeroProcesso': null,
        'instancia': null,
        'assunto': null,
        'objetoAcao': null,
        'comarca': null,
        'advogadoResponsavel': null,
        'advogadoContrario': null,
        'prognostico': null,
        'valorCausa': null,
        'valorCausa2': null,
        'dataDistribuicao': null,
        'fase': null,
        'ultimoAndamento': null,
        'produto': null,
        'valor': null
      },
      columns: [],
      columnsOpt: [
        { value: true, label: 'PROTOCOLO', key: 'protocolo' },
        { value: true, label: 'CPF/CNPJ', key: 'document' },
        { value: true, label: 'NOME', key: 'nome' },
        { value: true, label: 'RESPONSAVEL', key: 'responsavel' },
        { value: true, label: 'PA', key: 'nomePa' },
        { value: true, label: 'DIAS EM ABERTO', key: 'diasEmAberto' },
        { value: true, label: 'NUMERO PROCESSO', key: 'numeroProcesso' },
        { value: true, label: 'INSTANCIA', key: 'instancia' },
        { value: true, label: 'ASSUNTO', key: 'assunto' },
        { value: true, label: 'OBJETO DA AÇÃO', key: 'objetoAcao' },
        { value: true, label: 'COMARCA', key: 'comarca' },
        { value: true, label: 'ADVOGADO RESPONSÁVEL', key: 'advogadoResponsavel' },
        { value: true, label: 'ADVGADO CONTRÁRIO', key: 'advogadoContrario' },
        { value: true, label: 'PROGNÓSTICO', key: 'prognostico' },
        { value: true, label: 'VALOR CAUSA', key: 'valorCausa' },
        { value: true, label: 'VALOR CAUSA 2', key: 'valorCausa2' },
        { value: true, label: 'DATA DISTRIBUICAO', key: 'dataDistribuicao' },
        { value: true, label: 'FASE', key: 'fase' },
        { value: true, label: 'ULTIMO ANDAMENTO', key: 'ultimoAndamento' },
        { value: true, label: 'PRODUTO', key: 'produto' },
        { value: true, label: 'VALOR', key: 'valor' },
        { value: false, label: 'NOME DO QUADRO', key: 'quadroNome' },
        { value: false, label: 'ABERTURA', key: 'abertura' },
        { value: false, label: 'USUÁRIO CRIADOR', key: 'criador' },
        { value: false, label: 'SITUAÇÃO', key: 'situacao' },
        { value: false, label: 'GERENTE', key: 'gerente' },
        { value: false, label: 'GERENTE RELACIONAMENTO', key: 'gerenteRelacionamento' },
        { value: false, label: 'ORIGEM', key: 'origem' },
        { value: false, label: 'AGENDAMENTO', key: 'agendamento' }
      ],
      selectedCard: null
    }
  },
  components: {
    AddConfirmation,
    ModalCard,
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch
  },
  // mounted () {
  //   this.$eventHub.on('Filter', ({ filters }) => {
  //     this.filters = filters
  //     if (filters.dataInicial) {
  //       this.filters.dataInicial = this.moment(filters.dataInicial).format('YYYY-MM-DDT03:00:00.000')
  //     }
  //     if (filters.dataFinal) {
  //       this.filters.dataFinal = this.moment(filters.dataFinal).format('YYYY-MM-DDT03:00:00.000')
  //     }
  //     this.$refs.tableGrid.Clear()
  //     this.$nextTick(() => {
  //       this.onLoadAll()
  //     })
  //   })
  // },
  // beforeDestroy () {
  //   this.$eventHub.off('Filter')
  //   Tools.MinimizedASidebar()
  // },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onLoad () {
      this.setVisibleColumns()
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.filters = {
          'protocolo': null,
          'document': null,
          'numeroProcesso': null,
          'instancia': null,
          'assunto': null,
          'objetoAcao': null,
          'comarca': null,
          'advogadoResponsavel': null,
          'advogadoContrario': null,
          'prognostico': null,
          'valorCausa': null,
          'valorCausa2': null,
          'dataDistribuicao': null,
          'fase': null,
          'ultimoAndamento': null
        }
        this.onLoadAll()
        this.onLoadPAs()
      }
    },
    load (params) {
      return ReportAjuizamentoRepository.GetAll(this.filters, {
        params
      })
    },
    onLoadAll () {
      loading.push()
      ReportAjuizamentoRepository.GetAllCardsReport(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.numero, 'text': x.descricao}))
          this.form.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    showConfirmationModal () {
      this.$refs['confirmation-modal'].showModal()
    },
    onExportExcel () {
      const cookieName = 'exportInProgress'

      if (CookieUtils.isExportInProgress(cookieName)) {
        toast.warning('A exportação já está em execução ou foi interrompida recentemente. Tente novamente mais tarde.', 'Atenção!')
        return
      }

      CookieUtils.startExport(cookieName)
      loading.push()

      const columnsFilter = this.columnsOpt.reduce((acc, col) => {
        acc[col.key] = col.value
        return acc
      }, {})

      const payload = {
        filter: this.filters,
        columnsFilter
      }

      ReportAjuizamentoRepository.ExportAllCardsReport(payload)
        .then((response) => {
          loading.close()

          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioAjuizamento.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)

          toast.success('Relatório exportado com sucesso!', 'Sucesso')
        })
        .catch(this.onException)
        .finally(() => {
          CookieUtils.completeExport(cookieName)
        })
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/ajuizamento/reportAjuizamento.vue